<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <template v-else-if="info.type === 'activities'">
              <td>
                <h6 class="mb-2">
                  <strong>{{ info.label }}:</strong>
                </h6>
                <value-activities-info
                  :infoData="{
                    price: infoData.price,
                    activity: {
                      name: infoData.activityName,
                      unit_production_name: infoData.unitProductionName,
                      group_name: infoData.groupName,
                    },
                  }"
                  v-if="infoData.activityName"
                />
              </td>
            </template>
            <template v-else-if="info.type === 'hours'">
              <td>
                <h6 class="mb-2">
                  <strong>{{ info.label }}:</strong>
                </h6>
                <template
                  v-if="infoData.hourTypes && infoData.hourTypes.length > 0"
                >
                  <span
                    v-for="(value, index) in infoData.hourTypes"
                    :key="index"
                  >
                    <el-tag type="info">
                      {{ value }} =
                      {{
                        infoData.priceFormats[index] === '$'
                          ? infoData.priceFormats[index]
                          : ''
                      }}
                      {{ formatNumber(infoData.additional_percentage[index]) }}
                      {{
                        infoData.priceFormats[index] === '%'
                          ? infoData.priceFormats[index]
                          : ''
                      }}
                      {{ $t('common_words.additional') }}
                    </el-tag>
                  </span>
                </template>
                <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                  $t('common_words.no_assignment')
                }}</el-tag>
              </td>
            </template>
            <template v-else-if="info.type === 'rates'">
              <td>
                <h6 class="mb-2">
                  <strong>{{ info.label }}:</strong>
                </h6>
                <rate-types-info
                  :rates="infoData.rate_types"
                  v-if="infoData.rate_types.length > 0"
                />
                <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                  $t('common_words.no_assignment')
                }}</el-tag>
              </td>
            </template>
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import moment from 'moment';
import RateTypesInfo from '../RateTypesInfo.vue';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';
import ValueActivitiesInfo from '../ValueActivitiesInfo.vue';

export default {
  name: 'step-confirm',
  components: {
    [ValueActivitiesInfo.name]: ValueActivitiesInfo,
    [RateTypesInfo.name]: RateTypesInfo,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.activity'),
          type: 'activities',
        },
        {
          label: i18n.t('labor.hours_extra'),
          value: this.infoData.extra_hours === 1 ? 'Si' : 'No',
        },
        {
          label: i18n.t('common_words.selected_companies'),
          value: this.infoData.businessesNames,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.selected_farms'),
          value: this.infoData.farmsNames,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.selected_allotments'),
          value: this.infoData.lotsNames,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.starting_date'),
          value: this.formatDate(this.infoData.start_date),
        },
        {
          label: i18n.t('labor.hour_type'),
          value: this.infoData.hourTypes,
          type: 'hours',
        },
        {
          label: i18n.t('labor.rate_additional'),
          value: this.infoData.rate_types,
          type: 'rates',
        },
      ];
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    formatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },
    showInfoTag(info) {
      return (
        (typeof info.visibility === 'undefined' || Boolean(info.visibility)) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value) &&
        info.type !== 'activities' &&
        info.type !== 'hours' &&
        info.type !== 'rates'
      );
    },
  },
};
</script>
